module.exports = __webpack_public_path__ + "img/ITcomp.bd3c6f7c.svg";